/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectItemSubmittalCommandResult } from '../../models/create-project-item-submittal-command-result';
import { SubmissionStage } from '../../models/submission-stage';
import { VendorDataForCreateVm } from '../../models/vendor-data-for-create-vm';

export interface ApiProjectItemSubmittalsCreateProjectItemSubmittalPost$Plain$Params {
      body?: {
'ProjectId'?: string;
'SubmittalDate'?: string;
'SubmittalTitle'?: string;
'SubmissionStage'?: SubmissionStage;
'ParentId'?: string;
'ProjectItemIds'?: Array<string>;
'Vendors'?: Array<VendorDataForCreateVm>;
}
}

export function apiProjectItemSubmittalsCreateProjectItemSubmittalPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectItemSubmittalsCreateProjectItemSubmittalPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectItemSubmittalCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemSubmittalsCreateProjectItemSubmittalPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectItemSubmittalCommandResult>;
    })
  );
}

apiProjectItemSubmittalsCreateProjectItemSubmittalPost$Plain.PATH = '/api/ProjectItemSubmittals/CreateProjectItemSubmittal';
